import { render } from "./optional-filters-wrapper.vue?vue&type=template&id=5419eaa2&ts=true"
import script from "./optional-filters-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./optional-filters-wrapper.ts?vue&type=script&lang=ts&external"

import "./optional-filters-wrapper.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__